import type { SVGProps } from 'react';

export const Mail = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.3 19.5c-.5 0-.925-.175-1.275-.525A1.736 1.736 0 0 1 2.5 17.7V6.3c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525h15.4c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v11.4c0 .5-.175.925-.525 1.275-.35.35-.775.525-1.275.525H4.3ZM20 7.45l-7.525 4.8a.978.978 0 0 1-.225.125 1.27 1.27 0 0 1-.5 0 .978.978 0 0 1-.225-.125L4 7.45V17.7c0 .083.025.158.075.225.067.05.142.075.225.075h15.4a.27.27 0 0 0 .2-.075.31.31 0 0 0 .1-.225V7.45ZM12 11l7.85-5H4.15L12 11ZM4 7.45v.225-1.15.025V6v.55-.025 1.15-.225V18 7.45Z" />
    </svg>
  );
};
